import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  cardMain: {
    marginBottom: 0,
    paddingTop: 2,
    paddingBottom: theme.spacing(2),
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    color: "#000",
  },
  outer: {
    border: "0.5px solid #E6E6E6",
    borderRadius: "8px",
    boxShadow: "0px 0px 2px #00000029",
    padding: theme.spacing(2, 2.5),
    marginTop: theme.spacing(1.5),
  },
  fieldBox: {
    width: "100%",
    "& .MuiAutocomplete-root": {
      margin: 0,
    },
    "& .MuiFormControl-root": {
      margin: 0,
    },
  },
  buttonBox: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      marginLeft: theme.spacing(1.25),
    },
    "& > span": {
      marginBottom: "0 !important",
    },
  },
  printButton: {
    color: "#ffffff",
    backgroundColor: "#72CA00",
    padding: "6px 20px",
    width: "auto",
    minWidth: 130,
    height: 40,
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#65b500",
    },
  },
}));
